import { Email } from './e-mail.model';
export class Emailresponse {
    emails: Email[];
    errorCode: any;
    errorDescription: string;
    errorMessage: string;
}
